const origin = 'https://www.suriyaprakash.in'
const labels: Record<string, string> = {
  '/work': 'Work',
  '/playground': 'React component playground',
  '/playground/datatable': 'React DataTable demo',
  '/playground/schemaform': 'React SchemaForm builder',
  '/playground/querybuilder': 'React QueryBuilder demo',
}

export function pageBreadcrumb(pathname: string) {
  const path = pathname.replace(/\/$/, '')
  if (!Object.hasOwn(labels, path)) return []
  const paths = [
    '/',
    ...(path.startsWith('/playground/') ? ['/playground'] : []),
    path,
  ]
  return [
    {
      type: 'application/ld+json',
      children: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: paths.map((item, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          name: item === '/' ? 'Home' : labels[item],
          item: `${origin}${item}`,
        })),
      }).replace(/</g, '\\u003c'),
    },
  ]
}
